import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['secondInput']

  connect() {
    const filterElement = this.context.element
    const value = this.context.element.querySelector('#condition_selector')?.value
    if (filterElement && value) {
      this.evaluateConditionChange(filterElement, value)
    }
  }

  onConditionChange(e) {
    const { value } = e.target
    const filterElement = e.target.closest('[data-filter-param-id]')
    this.evaluateConditionChange(filterElement, value)
  }

  evaluateConditionChange(filterElement, value) {
    const valueField = filterElement.querySelector('[data-control="value"]')
    const noValueConditions = ['is_present', 'is_blank', 'is_true', 'is_false', 'is_null', 'is_not_null']

    if (this.hasSecondInputTarget) {
      if (value === 'is_within') {
        this.secondInputTarget.classList.remove('hidden')
      } else {
        this.secondInputTarget.classList.add('hidden')
      }
    }

    if (noValueConditions.includes(value)) {
      valueField.classList.add('hidden')
    } else {
      valueField.classList.remove('hidden')
    }
  }
}
